// This file should contain ALL keys used by *any* environment
// the values in this file should be that of the DEVELOPMENT environment
// other named environment files (i.e. environment.smoke.ts) should include ONLY overrides to values as necessary
// Common configs point to nightly environment

export const commonConfig = {
    appId: 'savvaslearning',
    apiGateway: {
    },
    authCallbackRoute: 'google/class/auth-callback',
    authContextId: '6065',
    authGatewayBaseUrl: 'https://rr-auth-gateway.nightly.savvasrealizedev.com/sapi',
    fmsBaseUrl: 'https://feature-management-service.nightly.savvasrealizedev.com/feature-management-service',
    production: false,
    profileIdentityId: 'profile.identityId',
    profileLocale: 'profile.locale',
    realizeBaseUrl: 'https://nightly-www.savvasrealizedev.com',
    classGuideUrl: 'https://help.learningservicestechnology.com/realize/en/Instructor/Content/Instructor/Classes/gc_class_connect.htm',
    rbsConfig: {
        clientId: 'lJEsPqfPnFZ0zdTlPBDptA1rfwL3GR6l',
        grant_type: 'custom_castgc',
        scope: 'rbs',
    },
    rumbaLoginBaseUrl: 'https://nightly-sso.rumba.pk12ls.com',
    ssoBaseUrl: 'https://nightly-sso.rumba.pk12ls.com/sso',
    ssoLoginParams: {
        k12int: true,
        profile: 'realize',
    },
    standalone: false,
    useUserRoleAsRbsScope: true,
    // end lst-auth library required properties
    i18nLocalePath: 'assets/i18n/',
    accountLinkingButtonConfig: {
        remoteEntryUrl: 'https://stage.google-user-webapp.savvasrealizedev.com/google/user/remoteEntry.json',
        exposedModuleKey: './GoogleUserWebappElement',
        elementTagName: 'app-account-linking-button',
        remoteName: 'google-user-webapp',
    },
    accountLinkingButtonLegacyConfig: {
        remoteEntryUrl: 'https://stage.google-user-webapp.savvasrealizedev.com/accountLinkingRemoteEntry.js',
        remoteAppName: 'account_linking',
        exposedResource: 'AccountLinkingButtonModule',
        componentName: 'AccountLinkingButtonComponent',
        exposedModuleName: './AccountLinkingButtonModule',
    },
};
